import React from "react";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Red watermark banner shown on every authenticated page when the signed-in
 * user is tagged `demo_district: true` on their user record.
 *
 * Phase D3 safety net: a sales rep logged into a demo district should never
 * mistake fictitious seeded data for real student records. Renders nothing
 * for anonymous visitors or real-district users — zero visual impact on
 * production users.
 */
const DemoDistrictBanner = () => {
  const { user } = useAuth();
  if (!user?.demo_district) return null;

  return (
    <div
      className="w-full bg-red-600 text-white text-center py-2 px-4 text-sm font-semibold flex items-center justify-center gap-2"
      data-testid="demo-district-banner"
      role="alert"
    >
      <AlertTriangle size={16} />
      <span>DEMO · NOT ACTUAL STUDENT DATA · All students, schools, and scores shown are fictitious.</span>
    </div>
  );
};

export default DemoDistrictBanner;

